module.exports = __webpack_public_path__ + "img/success-dog.47792fc3.png";